import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/login_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-015eabb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-full bg-tradelaboBlue",
  src: _imports_0,
  alt: "Login Logo"
}, null, -1))
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "text-center text-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}